import { formatPercent } from '../theme/format';

// Gladys' ambient mood, computed by code from the portfolio pulse (GET
// /portfolio/pulse), never asked to a model. mascot is the Mascotte /
// MascotteSpine state she takes when nothing else is going on.
//
//   sleep    weekend, or night (22:00-07:00)          idle, dimmed, "z"
//   alert    move beyond the alert threshold          wave (she signals)
//   storm    account down 1.5 % or more               surprise (agitated)
//   cloudy   down between 0.3 and 1.5 %               think
//   calm     within ±0.3 %, or no move known          idle
//   sunny    up between 0.3 and 1.5 %                 smile (relaxed)
//   radiant  up 1.5 % or more                         present
//   rest     weekday, market closed                   idle

export const MOODS = {
  sleep: { mascot: 'idle', label: 'Gladys dort' },
  alert: { mascot: 'wave', label: 'Gladys vous fait signe' },
  storm: { mascot: 'surprise', label: 'Gladys est agitée' },
  cloudy: { mascot: 'think', label: 'Gladys est songeuse' },
  calm: { mascot: 'idle', label: 'Gladys est sereine' },
  sunny: { mascot: 'smile', label: 'Gladys est détendue' },
  radiant: { mascot: 'present', label: 'Gladys rayonne' },
  rest: { mascot: 'idle', label: 'Gladys se repose' },
};

const minutesOf = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || '');
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
};

const moveText = (pct) => `votre portefeuille ${pct >= 0 ? 'progresse' : 'recule'} de ${formatPercent(Math.abs(pct), { sign: false })} aujourd’hui`;

export const ambientMood = (pulse) => {
  if (!pulse) return { mood: 'calm', ...MOODS.calm, detail: '' };
  const pct = pulse.day_change_pct;
  const known = pct !== null && pct !== undefined;
  const minutes = minutesOf(pulse.local_time);
  const night = minutes !== null && (minutes >= 22 * 60 || minutes < 7 * 60);
  let mood;
  if (pulse.weekend || night) mood = 'sleep';
  else if (pulse.alert && known) mood = 'alert';
  else if (!pulse.market_open) mood = 'rest';
  else if (!known) mood = 'calm';
  else if (pct <= -1.5) mood = 'storm';
  else if (pct <= -0.3) mood = 'cloudy';
  else if (pct < 0.3) mood = 'calm';
  else if (pct < 1.5) mood = 'sunny';
  else mood = 'radiant';

  let detail;
  if (mood === 'sleep') detail = pulse.weekend ? 'Les marchés sont fermés ce week-end.' : 'Les marchés dorment aussi.';
  else if (mood === 'alert') detail = `Alerte : ${moveText(pct)}.`;
  else if (mood === 'rest') detail = known ? `Marché fermé : ${moveText(pct)}.` : 'Le marché est fermé.';
  else if (known) detail = `${moveText(pct).replace(/^v/, 'V')}.`;
  else detail = 'Variation du jour indisponible.';
  if (pulse.index_change_pct !== null && pulse.index_change_pct !== undefined && mood !== 'sleep') {
    detail += ` CAC 40 : ${formatPercent(pulse.index_change_pct)}.`;
  }
  return { mood, ...MOODS[mood], detail, pct: known ? pct : null };
};

export const PULSE_REFRESH_MS = 5 * 60 * 1000;
